const lotsByPalletId = new Map();

function getCachedLots(palletId) {
    return lotsByPalletId.get(palletId);
}

function setCachedLots(palletId, lots) {
    lotsByPalletId.set(palletId, lots);
}

function clearBulkMovePalletsLotsCache() {
    lotsByPalletId.clear();
}

export { clearBulkMovePalletsLotsCache, getCachedLots, setCachedLots };
